import React from 'react'
import { Logo } from './HeroSection6'

export default function LandingFooter() {
  return (
    <footer className="border-t border-border/60 py-6">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 text-sm text-foreground/70">
        <span>© {new Date().getFullYear()} Cripto Alert</span>
        <Logo className="h-7" />
      </div>
    </footer>
  )
}

